module.exports = __webpack_public_path__ + "static/media/SundaySpecial2x.b755c275.png";